import { useState, useEffect } from 'react';
import { Card, Location } from 'soxo-bootstrap-core';
import VisitInfo from '../../emr/components/visit-info/visit-info';
import PatientListResearch from '../../imaging/components/patient-list/patient-list';
import { Clinicals } from '../../../models';

export default function MergedReport({
    opb_id,
    OPNo,
    disablePagination,
    defaultScaleValue,
    defaultSizes,
    viewerType,
    path,
    doctorNote,
    // Set attribute for show 'Create Report' Button
    isShowCreateReportButton,
    ...props
}) {
    const [guest, setGuest] = useState({});
    const [referenceId, setReferenceId] = useState(opb_id);
    const [loading, setLoading] = useState(true);

    const urlParams = Location.search();

    useEffect(() => {
        // Check if either 'opb_id' exists in the URL parameters
        // or if there is an 'opb_id' available from another source (like props or state).
        if (urlParams.opb_id || opb_id) {
            // If the condition is true, call the function 'getGuestData'
            // and pass the latest 'referenceId' to fetch guest-related data.
            getGuestData(referenceId);
        }
    }, [referenceId]);

    // Fetch Guest data
    async function getGuestData(refId) {
        setLoading(true);
        try {
            await Clinicals.getVitalInformation(refId);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Card className="merged-report">
            <div className="section-1">
                {/* Guest Information */}
                <VisitInfo
                    mode="opreg"
                    reference_number={urlParams.opno || OPNo}
                    enableBillnumber
                    startLoading={() => setLoading(true)}
                    onReceiveGuestDetails={(patient) => setGuest(patient)}
                    callback={async (values, bills) => {
                        setReferenceId(values);
                        const record = bills.find((ele) => ele.opb_id === values);
                        if (record && urlParams.opb_id !== record.opb_id) {
                            Location.navigate({
                                url: `${path || ''}?opb_id=${record.opb_id}&opb_no=${record.opb_bno}&opno=${record.opb_opno}`,
                            });
                        }
                        await getGuestData(record.opb_id);
                    }}
                />

                {/* Patient List Search */}
                <div style={{ marginTop: '10px' }}>
                    {!loading && (
                        <PatientListResearch
                            match=""
                            mode="TECH"
                            defaultScaleValue={defaultScaleValue}
                            defaultSizes={defaultSizes}
                            viewerType={viewerType}
                            disablePagination={disablePagination}
                            reference_id={referenceId}
                            doctorNote={doctorNote}
                            isShowCreateReportButton={isShowCreateReportButton}
                            {...props}
                        />
                    )}
                </div>
            </div>
        </Card>
    );
}
